module.exports = __webpack_public_path__ + "img/split-pax.068e4727.svg";